module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("vux 使用 nuxt 实现服务端渲染")]), _vm._v(" "), _c('p', [_vm._v("请直接参考源码目录 "), _c('a', {
    attrs: {
      "href": "https://github.com/airyland/vux/tree/v2/ssr/nuxt"
    }
  }, [_vm._v("/ssr/nuxt")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1cd24e6a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-1cd24e6a"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/vux-nuxt-ssr-168.vue
// module id = 2073
// module chunks = 195